// Movs Street — small progressive enhancements. The store works without JS.

// [ENTER] screen over the main page: shown once per visit, then the page underneath appears.
(() => {
  const splash = document.querySelector('[data-splash]');
  if (!splash) return;

  // Theme editor: only show it while its section is selected.
  if (splash.hasAttribute('data-design-mode')) {
    const section = splash.closest('.shopify-section');
    document.addEventListener('shopify:section:select', (e) => { if (e.target === section) splash.hidden = false; });
    document.addEventListener('shopify:section:deselect', (e) => { if (e.target === section) splash.hidden = true; });
    return;
  }

  let seen = false;
  try { seen = splash.dataset.once === 'true' && sessionStorage.getItem('movs-entered') === '1'; } catch (e) {}
  if (seen) { splash.hidden = true; return; }
  document.body.classList.add('splash-open');
  const enter = (event) => {
    event?.preventDefault();
    if (splash.classList.contains('is-leaving')) return;
    try { sessionStorage.setItem('movs-entered', '1'); } catch (e) {}
    splash.classList.add('is-leaving');
    document.body.classList.remove('splash-open');
    window.scrollTo(0, 0);
    setTimeout(() => { splash.hidden = true; }, 1200);
    document.dispatchEvent(new CustomEvent('movs:entered'));
  };
  splash.querySelector('[data-splash-enter]')?.addEventListener('click', enter);
  document.addEventListener('keydown', (e) => { if (!splash.hidden && e.key === 'Enter' && document.activeElement === document.body) enter(); });
})();

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-drawer-open]');
  if (opener) {
    const drawer = document.getElementById(opener.dataset.drawerOpen);
    if (drawer) {
      drawer.setAttribute('open', '');
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      drawer.querySelector('a, button')?.focus();
    }
    return;
  }

  const closer = event.target.closest('[data-drawer-close]');
  if (closer) closeDrawer(closer.closest('.drawer'));

  const toggle = event.target.closest('[data-toggle]');
  if (toggle) {
    const target = document.getElementById(toggle.dataset.toggle);
    if (!target) return;
    const hidden = target.hasAttribute('hidden');
    target.toggleAttribute('hidden', !hidden);
    toggle.setAttribute('aria-expanded', String(hidden));
    if (hidden) target.querySelector('input')?.focus();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeDrawer(document.querySelector('.drawer[open]'));
});

function closeDrawer(drawer) {
  if (!drawer) return;
  drawer.removeAttribute('open');
  document.body.style.overflow = '';
  const opener = document.querySelector(`[data-drawer-open="${drawer.id}"]`);
  opener?.setAttribute('aria-expanded', 'false');
  opener?.focus();
}

// Auto-submit sort, filter and language forms on change.
document.addEventListener('change', (event) => {
  const form = event.target.closest('form[data-auto-submit], form.lang-form');
  if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
});

// Product page: swap price / button state when a variant is chosen.
document.querySelectorAll('[data-variant-select]').forEach((select) => {
  const root = select.closest('[data-product]');
  const variantsEl = root?.querySelector('[data-variants]');
  if (!variantsEl) return;
  const variants = JSON.parse(variantsEl.textContent);
  const button = root.querySelector('[data-add-button]');
  const price = root.querySelector('[data-price]');

  select.addEventListener('change', () => {
    const variant = variants.find((v) => String(v.id) === select.value);
    if (!variant) return;
    if (price) price.innerHTML = variant.price_html;
    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.labelAvailable : button.dataset.labelSoldOut;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  });
});

// Product gallery: arrows, thumbnails and full-screen zoom.
document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('.gallery__track');
  const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
  if (!track) return;
  const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  const current = () => Math.round(track.scrollLeft / track.clientWidth);
  gallery.querySelector('[data-prev]')?.addEventListener('click', () => go(Math.max(0, current() - 1)));
  gallery.querySelector('[data-next]')?.addEventListener('click', () => go(Math.min(track.children.length - 1, current() + 1)));
  thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
  track.addEventListener('scroll', () => {
    const i = current();
    thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
  }, { passive: true });
});

const lightbox = document.getElementById('Lightbox');
if (lightbox && typeof lightbox.showModal === 'function') {
  const lightboxImg = document.createElement('img');
  lightboxImg.className = 'lightbox__img';
  lightbox.append(lightboxImg);
  document.addEventListener('click', (event) => {
    const item = event.target.closest('[data-zoom]');
    if (!item || !event.target.closest('img')) return;
    lightboxImg.src = item.dataset.zoom;
    lightboxImg.alt = item.querySelector('img')?.alt || '';
    lightbox.showModal();
  });
  lightbox.addEventListener('click', () => lightbox.close());
}

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Header: hide when scrolling down, show when scrolling up.
(() => {
  const header = document.querySelector('[data-autohide]');
  if (!header) return;
  let last = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (document.querySelector('.drawer[open], .cart-drawer.is-open')) return;
    header.classList.toggle('is-hidden', y > last && y > 160);
    last = y;
  }, { passive: true });
})();

// Split headlines into letters that rise in.
document.querySelectorAll('[data-split]').forEach((el) => {
  const text = el.textContent.trim();
  el.setAttribute('aria-label', text);
  el.innerHTML = [...text].map((ch, i) =>
    ch === ' ' ? ' ' : `<span class="split-char" aria-hidden="true"><span style="--i:${i}">${ch.replace(/[&<>"]/g, (c) => `&#${c.charCodeAt(0)};`)}</span></span>`
  ).join('');
});

// Scroll reveal, staggered within each group.
(() => {
  if (!document.documentElement.classList.contains('anim')) return;
  const groups = ['.grid', '.masonry', '.drop__head', '.section-heading', '.brands-section', '.statement', '.image-text', '.newsletter', '.product__info', '.insta', '.footer__grid'];
  const targets = [];
  groups.forEach((sel) => document.querySelectorAll(sel).forEach((group) => {
    const kids = group.matches('.grid, .masonry, .insta, .footer__grid, .product__info, .image-text') ? [...group.children] : [group];
    kids.forEach((el, i) => { el.setAttribute('data-reveal', ''); el.style.setProperty('--i', Math.min(i % 8, 7)); targets.push(el); });
  }));
  document.querySelectorAll('[data-split]').forEach((el) => targets.push(el));
  if (!('IntersectionObserver' in window) || reduceMotion) { targets.forEach((el) => el.classList.add('is-visible')); return; }
  const io = new IntersectionObserver((entries) => entries.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  const start = () => targets.forEach((el) => io.observe(el));
  // Behind the [ENTER] screen, wait until the visitor goes in so they see the entrance.
  if (document.body.classList.contains('splash-open')) document.addEventListener('movs:entered', () => setTimeout(start, 350), { once: true });
  else start();
})();

// Library backdrop moves slower than the page.
(() => {
  const img = document.querySelector('.backdrop__media img');
  if (!img || reduceMotion) return;
  let ticking = false;
  const update = () => {
    const y = Math.min(window.scrollY, window.innerHeight * 1.2);
    img.style.transform = `translate3d(0, ${y * 0.3}px, 0) scale(1.08)`;
    ticking = false;
  };
  window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
  update();
})();

// Countdown to the next weekly drop, in the store's time zone.
document.querySelectorAll('[data-countdown]').forEach((el) => {
  const weekday = Number(el.dataset.weekday);
  const hour = Number(el.dataset.hour);
  const minute = Number(el.dataset.minute);
  const liveMs = Number(el.dataset.liveHours || 2) * 3600e3;
  const m = /([+-])(\d{2})(\d{2})/.exec(el.dataset.offset || '+0000');
  const offsetMs = (m ? (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) : 0) * 60e3;
  const label = el.querySelector('[data-countdown-label]');
  const units = { d: el.querySelector('[data-unit="d"]'), h: el.querySelector('[data-unit="h"]'), m: el.querySelector('[data-unit="m"]'), s: el.querySelector('[data-unit="s"]') };
  const pad = (n) => String(n).padStart(2, '0');

  const tick = () => {
    const now = Date.now();
    const shop = new Date(now + offsetMs); // shop wall-clock expressed in UTC fields
    const target = new Date(Date.UTC(shop.getUTCFullYear(), shop.getUTCMonth(), shop.getUTCDate(), hour, minute));
    target.setUTCDate(target.getUTCDate() + ((weekday - shop.getUTCDay() + 7) % 7));
    let diff = target - shop;
    const sinceLast = diff <= 0 ? -diff : 7 * 864e5 - diff;
    const live = sinceLast < liveMs;
    if (diff <= 0) diff += 7 * 864e5;
    el.classList.toggle('is-live', live);
    label.textContent = live ? label.dataset.live : label.dataset.next;
    const s = Math.floor(diff / 1000);
    units.d.textContent = pad(Math.floor(s / 86400));
    units.h.textContent = pad(Math.floor((s % 86400) / 3600));
    units.m.textContent = pad(Math.floor((s % 3600) / 60));
    units.s.textContent = pad(s % 60);
  };
  tick();
  setInterval(tick, 1000);
});

// Cart drawer: add without leaving the page, re-render through the Section Rendering API.
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const open = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close]')?.focus({ preventScroll: true });
  };
  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  const setCount = (count) => {
    const link = document.querySelector('[data-cart-open]');
    if (!link) return;
    let badge = link.querySelector('[data-cart-count]');
    if (!badge && count > 0) {
      badge = document.createElement('span');
      badge.className = 'cart-count';
      badge.setAttribute('data-cart-count', '');
      link.append(badge);
    }
    if (!badge) return;
    badge.textContent = count;
    badge.hidden = count === 0;
    badge.classList.remove('is-bumping'); void badge.offsetWidth; badge.classList.add('is-bumping');
  };
  const refresh = async () => {
    drawer.classList.add('is-loading');
    const res = await fetch(`${root}?sections=cart-drawer`);
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer] .cart-drawer__panel');
    if (fresh) drawer.querySelector('.cart-drawer__panel').replaceWith(fresh);
    const cart = await (await fetch(`${root}cart.js`)).json();
    setCount(cart.item_count);
    drawer.classList.remove('is-loading');
  };

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cart-close]')) { if (e.target.closest('a[href]')) close(); else { e.preventDefault(); close(); } return; }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      drawer.classList.add('is-loading');
      await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 }) });
      await refresh();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (e.submitter && e.submitter.name !== 'add') return; // let express checkout buttons through
      e.preventDefault();
      const button = form.querySelector('[data-add-button]');
      const label = button?.textContent;
      form.querySelector('.product-form__error')?.remove();
      if (button) { button.disabled = true; button.textContent = button.dataset.labelAdding || label; }
      try {
        const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!res.ok) throw new Error('add');
        await refresh();
        open();
        if (button) { button.textContent = button.dataset.labelAdded || label; }
        setTimeout(() => { if (button) { button.disabled = false; button.textContent = label; } }, 2500);
      } catch (err) {
        if (button) { button.disabled = false; button.textContent = label; }
        const p = document.createElement('p');
        p.className = 'product-form__error';
        p.setAttribute('role', 'alert');
        p.textContent = button?.dataset.labelError || 'Error';
        form.append(p);
      }
    });
  });
})();
